import axios from 'axios';
import {store} from '../store';

export const BASE_URL = 'https://yakov.owal.io';

export function makeRequest(path, params) {
  params = params || {};
  params.token = store.getters.authToken;
  const headers = {
    authorization: `Bearer ${store.getters.authToken}`
  }
  console.log(`Making request to ${path} with: `, params);
  return axios.post(BASE_URL + path, params, { headers });
}

export function getRequest (path, params) {
  return axios.get(BASE_URL + path + (params ? '?' + params: ''), {headers: {Authorization: `Bearer ${store.getters.authToken}`}})
}



// WEBPACK FOOTER //
// ./src/api/base.js